module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9744/js/img/MarketingHub_Icon.svg"